import React, { useEffect, useState } from "react";
import { ChangeTitle, toAbsoluteUrl } from "../../helpers/Reusable";
import { useLocation } from "react-router-dom";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import { getCookie } from "../../helpers/CookieComponent";

const TrainingDetails = () => {
  ChangeTitle("Training Details");
  const location = useLocation();
  // const { trainingId } = location.state || {};
  const trainingId = getCookie("trainingId");
  const [trainingDetails, setTrainingDetails] = useState();

  // Training Details API Call
  const viewTrainingDetailsList = async (id) => {
    const param = {
      trainingId: id,
    };

    console.log(id);

    var response = await postData("training/detail", param, apiHeader(false));
    console.log(response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data[0];
      setTrainingDetails(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewTrainingDetailsList(trainingId);
  }, [trainingId]);

  return (
    <>
      <div className="w-full p-[5%] section-books section-training">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[2%]">
            <h1 className="hanson text-center mb-[1%] ap5-h1">Training</h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          {trainingDetails && (
            <div className="w-full section-taining-details">
              <div className="w-full sm:w-[80%] md:w-[70%] lg:w-[60%] xl:w-[50%] mb-[3%] mx-auto flex justify-center items-center px-[2%] py-[5%] md:p-[2%] std-part1">
                <h1 className="pr-[4%] stdp1-h1">
                  {trainingDetails && trainingDetails.batchName}{" "}
                  {trainingDetails && trainingDetails.startDate}
                </h1>
                <h1 className="pl-[4%] stdp1-h1">
                  Duration: {trainingDetails && trainingDetails.duration} Days
                </h1>
              </div>
              <div className="p-[5%] sm:p-[2%] mb-[5%] md:mb-[3%] std-part2 highlights">
                <h1 className="mb-[2%] stdp2-title">Highlights</h1>
                <ul className="w-[90%] md:w-[95%] lg:w-[97%] mx-auto grid gap-y-4 gap-x-20 sm:grid-cols-2 lg:grid-cols-3 stdp2-ul">
                  <li className="stdp2ul-li">
                    {trainingDetails && trainingDetails.highlight}
                  </li>
                  {/* <li className="stdp2ul-li">
                  Registration, Return & Penalties Under Corporate Tax
                </li>
                <li className="stdp2ul-li">
                  Provision related to Free Zone Person
                </li>
                <li className="stdp2ul-li">
                  PE, Qualifying Group, and Tax Groups
                </li>
                <li className="stdp2ul-li">
                  Related Party Transaction, Transfer Pricing, GAAR
                </li>
                <li className="stdp2ul-li">
                  Computation of Tax under Corporate Tax
                </li> */}
                </ul>
              </div>
              <div className="flex flex-col mb-[5%] md:mb-[3%] md:flex-row gap-10 std-part3">
                <div className="md:w-[50%] p-[5%] sm:p-[2%] stdp3-part1">
                  <div className="mb-[5%] stdp3p1p1">
                    <h1 className="mb-[2%] stdp3-h1">Faculty</h1>
                    <ul className="ml-[5%] stdp3-ul">
                      <li className="stdp3ul-li">
                        {trainingDetails && trainingDetails.faculty}
                      </li>
                    </ul>
                  </div>
                  <div className="stdp3p1p2">
                    <h1 className="mb-[2%] stdp3-h1">Useful for</h1>
                    <ul className="ml-[5%]  stdp3-ul">
                      <li className="stdp3ul-li">
                        {trainingDetails && trainingDetails.usefulFor}
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="md:w-[50%] p-[5%] sm:p-[2%] stdp3-part2">
                  <h1 className="mb-[2%] stdp3-h1">What you get</h1>
                  <ul className="ml-[5%] stdp3-ul">
                    <li className="stdp3ul-li">
                      {trainingDetails && trainingDetails.whatYouGet}
                    </li>
                    {/* <li className="stdp3ul-li">
                    Digital LIVE Interactive Classes
                  </li>
                  <li className="stdp3ul-li">
                    Q & A Session after every class for doubt-clearing
                  </li>
                  <li className="stdp3ul-li">
                    Quick MCQ-based assessment for self-analysis Speakers &
                    Professionals with 20+ year’s experience
                  </li> */}
                  </ul>
                </div>
              </div>
              <div className="w-full std-part4">
                <h1 className="w-full text-center mb-[3%] md:mb-[1%] stdp4-h1">
                  Course fee
                </h1>
                <div className="w-full justify-center mb-[3%] md:mb-[1%] items-center mx-auto flex stdp4-h2s">
                  <h2 className="px-[2%] stdp4-h2">
                    INR{" "}
                    {trainingDetails.fees &&
                      trainingDetails.fees.INR.toFixed(2)}
                  </h2>
                  <h2 className="px-[2%] stdp4-h2">
                    USD{" "}
                    {trainingDetails.fees &&
                      trainingDetails.fees.USD.toFixed(2)}
                  </h2>
                  <h2 className="px-[2%] stdp4-h2">
                    AED{" "}
                    {trainingDetails.fees &&
                      trainingDetails.fees.AED.toFixed(2)}{" "}
                    inclusive of all taxes
                  </h2>
                </div>
                <h3 className="w-full text-center stdp4-h3">
                  Digital live interactive classes
                </h3>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TrainingDetails;
